import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Calendar } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-slate-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex-shrink-0">
            <img 
              src="/elit-logo.png" 
              alt="Elit Brand Tour" 
              className="h-12 w-auto"
            />
          </div>
          <div className="flex items-center gap-4 sm:gap-6">
            <div className="hidden md:flex items-center gap-2 text-white">
              <Calendar className="w-4 h-4 text-orange-400" />
              <span className="text-sm font-medium">Jueves 3 de Septiembre 2026</span>
            </div>
            <Button
              onClick={scrollToForm}
              className="bg-gradient-to-r from-orange-600 to-pink-600 hover:from-orange-700 hover:to-pink-700 text-white px-6 py-2 rounded-full transition-all duration-300 hover:scale-105"
            >
              Registrarme
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
